"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConjureNatureCrystalAbilityHandler = exports.ConjureNatureCrystalActorAbilityFactory = exports.ConjureNatureCrystalAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const core_1 = require("../../core/event-handlers/core");
const ts_essentials_1 = require("ts-essentials");
const CharmImmunity_1 = require("../../core/effects/core/CharmImmunity");
class ConjureNatureCrystalAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ConjureNatureCrystal;
        this.__typeName = "ConjureNatureCrystal";
    }
}
exports.ConjureNatureCrystalAbilityArgs = ConjureNatureCrystalAbilityArgs;
let ConjureNatureCrystalActorAbilityFactory = class ConjureNatureCrystalActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ConjureNatureCrystal", "Self", 2);
    }
};
ConjureNatureCrystalActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ConjureNatureCrystal")
], ConjureNatureCrystalActorAbilityFactory);
exports.ConjureNatureCrystalActorAbilityFactory = ConjureNatureCrystalActorAbilityFactory;
let ConjureNatureCrystalAbilityHandler = class ConjureNatureCrystalAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        (0, ts_essentials_1.assert)(!container.readLocal(ability.invokerId, "NatureCrystalActive", false), `100|CannotConjureSecondNatureCrystal`);
        container.setLocal(ability.invokerId, "NatureCrystalActive", true);
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                const invoker = container.getActor(ability.invokerId);
                const natureCrystalArgs = new ActorArgs_1.NpcActorArgs(invoker.faction, ActorType_1.ActorType.Magician_NatureCrystal, invoker.level, Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
                    let multiplier = .5;
                    pet[key] = Math.round(value * multiplier);
                    return pet;
                }, {}), {})
                    .withPlayerId(invoker.playerId)
                    .withAi("NoOp", {})
                    .withEffects({
                    effect: new CharmImmunity_1.CharmImmunityEffectArgs
                });
                const crystalId = container.summonCompanion(sequence, ability.invokerId, natureCrystalArgs);
                container.registerEventHandler(crystalId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new core_1.SetLocalValueEventHandlerArgs(ability.invokerId, "NatureCrystalActive", false));
            }
        });
    }
};
ConjureNatureCrystalAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ConjureNatureCrystal)
], ConjureNatureCrystalAbilityHandler);
exports.ConjureNatureCrystalAbilityHandler = ConjureNatureCrystalAbilityHandler;
